<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 线下服务 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 206px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover" style="min-height: 100px">
      <div style="padding: 10px" v-if="storeGuid">
        <x-table
          listApi="biz.customer.store.service.list"
          paginationLayout="total, sizes, prev, next, jumper"
          defaultSort="opt_status asc"
          actionFixed="right"
          emptyLabel="暂无服务信息"
          :btnList="btnList"
          :defaultParams="defaultParams"
          :fieldList="fieldList"
          :actionList="actionList"
          :actionWidth="120"
        >
          <template slot="row-info" slot-scope="scope">
            <warehouse-service-info :serviceInfo="scope.row" :imageSize="40" />
          </template>
        </x-table>
      </div>
      <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
    </el-card>
  </div>
</template>

<script>
import customerStoreSelect from '../../../../components/business/customerStoreSelect.vue';
import warehouseServiceInfo from '../../../../components/business/warehouseServiceInfo.vue';
import formPage from "./form.vue";

export default {
  components: {
    warehouseServiceInfo,
    customerStoreSelect
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
        storeGuid: this.storeGuid,
      }, this.queryModel || {});
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        queryValue: ""
      }
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({
      }, this.formInline);
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    }
  },
  data() {
    return {
      storeGuid: "",
      queryModel: {},
      formInline: {
        goodsType: '',
        minStock: "",
        maxStock: "",
        optWarning: "",
        queryValue: ''
      },
      fieldList: [
        {
          label: "服务信息",
          minWidth: "240",
          slot: 'info',
        },
        {
          label: '价格',
          width: '120',
          render: row => (row.price + "元"),
        },
      ],
      actionList: [
        {
          label: '编辑',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.store.service.update"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑服务项目信息',
              refresh,
              component: formPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid
              },
            });
          },
        },
        {
          label: "删除",
          linkType: 'danger',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.store.service.delete"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$confirm(`确定删除，此操作不可恢复，请谨慎操作?`, '提示', {
              type: 'warning',
            }, {
              showError: true
            }).then(() => {
              this.requestApi('biz.customer.store.service.delete', {
                guid: row.guid,
                storeGuid: row.storeGuid
              }, {
                showError: true
              }).then(() => {
                this.success('保存成功');
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: '新增服务',
          type: 'primary',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper",
              "biz.customer.store.service.create"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            // 新增线下服务
            this.$drawer.openDrawer({
              title: '新增服务',
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        }
      ],
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  }
};
</script>